import { render, staticRenderFns } from "./HoverButton.vue?vue&type=template&id=faad5712"
import script from "./HoverButton.vue?vue&type=script&lang=js"
export * from "./HoverButton.vue?vue&type=script&lang=js"
import style0 from "./HoverButton.vue?vue&type=style&index=0&id=faad5712&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports